import React, { Fragment } from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import i18n from 'i18n'
const Progress = styled(ProgressBar)`
  height: 0.375em;
  width: 100%;
  background-color: #212529;
  border-radius: 3px;
  .progress-bar {
    border-radius: 3px;
    background: linear-gradient(45deg, #11bed3 0%, #9cdf61 100%);
  }
`
const Label = styled.p`
  height: 1.5em;
  color: #717171;

  font-size: 0.875em;
  line-height: 1.5em;
  text-align: center;
  margin-bottom: 0;
`
const Detail = styled.p`
  height: 1.4em;
  margin-top: 0.313em;
  color: #717171;

  font-size: 0.875em;
  line-height: 1.125em;
`

export default function ProgressMeter(props) {
  const { progress } = props
  return (
    <Fragment>
      <Label>{`${progress}%`}</Label>
      <Progress now={progress} />
      <Detail>{i18n.t('influencer.dashboard.complete')}</Detail>
    </Fragment>
  )
}

ProgressMeter.propTypes = {
  progress: PropTypes.number,
}
